import createIcon from '../../createIcon';

/**
 * @component @name SignalWifiOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjMuNjQwNCA3LjU5NTI3QzIzLjE5MDMgNy4yNTUyNyAxOC43MTA0IDMuNTk1MjcgMTIuMDAwNCAzLjU5NTI3QzEwLjY4MDQgMy41OTUyNyA5LjQ1MDM1IDMuNzM1MjcgOC4zMTAzNSAzLjk3NTI3TDE4LjQzMDQgMTQuMDk1M0wyMy42NDA0IDcuNTk1MjdaTTMuNDEwMzUgMS45MDUyN0wyLjAwMDM1IDMuMzE1MjdMNC4wNTAzNSA1LjM2NTI3QzEuOTEwMzUgNi4zNTUyNyAwLjU5MDM1MiA3LjQxNTI3IDAuMzYwMzUyIDcuNTk1MjdMMTIuMDAwNCAyMi4wOTUzTDE1LjkxMDQgMTcuMjI1M0wxOS4yMzA0IDIwLjU0NTNMMjAuNjQwNCAxOS4xMzUzTDMuNDEwMzUgMS45MDUyN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SignalWifiOff = createIcon('SignalWifiOff', [
  [
    'path',
    {
      d: 'M23.6404 7.59527C23.1903 7.25527 18.7104 3.59527 12.0004 3.59527C10.6804 3.59527 9.45035 3.73527 8.31035 3.97527L18.4304 14.0953L23.6404 7.59527ZM3.41035 1.90527L2.00035 3.31527L4.05035 5.36527C1.91035 6.35527 0.590352 7.41527 0.360352 7.59527L12.0004 22.0953L15.9104 17.2253L19.2304 20.5453L20.6404 19.1353L3.41035 1.90527Z',
      key: '1ednt7',
    },
  ],
]);

export default SignalWifiOff;
